import React, { useMemo, useState } from "react";
import { Box, FormHelperText, InputLabel, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BRAND } from "../auth/authTheme";
import { FilterButton, PickerOption, PickerSheet } from "./PickerSheet";

const normalizeValue = (value, options) => {
  if (value === "" || value === null || value === undefined) return value;
  const match = options.find((opt) => String(opt.value) === String(value));
  return match ? match.value : value;
};

const MobileSelectField = ({
  label,
  value,
  onChange,
  options = [],
  helperText,
  disabled = false,
  placeholder = "Select",
  sheetTitle,
  sheetSubtitle,
  columns = 1,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);

  const normalizedValue = normalizeValue(value, options);

  const selectedLabel = useMemo(() => {
    const match = options.find(
      (opt) => String(opt.value) === String(normalizedValue)
    );
    return match ? match.label : "";
  }, [normalizedValue, options]);

  const displayLabel = selectedLabel || placeholder;

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setOpen(false);
  };

  if (!isMobile) {
    return null;
  }

  const title = sheetTitle || label;

  return (
    <Box sx={{ width: "100%" }}>
      {label && (
        <InputLabel
          shrink
          sx={{
            position: "relative",
            transform: "none",
            mb: 0.75,
            fontSize: "0.9375rem",
            fontWeight: 600,
            color: BRAND.navy,
          }}
        >
          {label}
        </InputLabel>
      )}
      <FilterButton
        label={displayLabel}
        onClick={() => setOpen(true)}
        isActive={open}
        disabled={disabled}
      />
      {helperText && (
        <FormHelperText sx={{ mx: 0, mt: 0.75, color: BRAND.muted }}>
          {helperText}
        </FormHelperText>
      )}

      <PickerSheet
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        subtitle={sheetSubtitle}
        preview={selectedLabel || undefined}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: columns > 1 ? `repeat(${columns}, 1fr)` : "1fr",
            gap: 0.75,
          }}
        >
          {options.map((option) => {
            const isSelected =
              String(normalizedValue) === String(option.value);
            return (
              <PickerOption
                key={String(option.value)}
                label={option.label}
                isSelected={isSelected}
                onClick={() => handleSelect(option.value)}
              />
            );
          })}
        </Box>
        {!options.length && (
          <Typography sx={{ color: BRAND.muted, fontSize: "0.875rem", py: 2, textAlign: "center" }}>
            No options available
          </Typography>
        )}
      </PickerSheet>
    </Box>
  );
};

export default MobileSelectField;
